module.exports = __webpack_public_path__ + "static/perpetual-swaps-header-e67c25cae523ee5f13ec92a5f28f6d42.png";